 import * as Icons  from './icons.js'
 
 
 const Icon = ({name, width, height, bg, color, className, style, id, exclude_wrapper, onClick = ()=>{}}) => {
    var icon;
    width = (!width) ?"16px" :  width
    if(!height){
        height = "16px"
    }
    if(!color){
        color = ""
    }
    if(!name){
        icon = ''
    }
    else if(name in Icons){
        icon = Icons[name]
    }
    else if(name.includes('bi-')){
        icon = <i id={id} className={`bi ${name}`} />
    }
    if(exclude_wrapper){
        return icon
    }
    return <span className={`icon-wrapper ${className} ${name.toLowerCase()}`} onClick={onClick} id={id} style={{height:height, width:width, color:color, ...style}}> {icon}</span>;
    
}

export default Icon